import { createTrackingUtils } from "..";
import useProfiler from "hooks/useProfiler";
import { UIFlightData } from "@flights/types";

const utils = createTrackingUtils({
  name: "flights_ade_sr_all_deals_filter",
  stages: {
    users_in_sr: 1,
    fare_discount_available: 2,
    d_dot_users: 3,
    d_dot_users_in_split_bound: 4,
    m_dot_users: 5,
    ios: 6,
    android: 7,
    centralised_filter: 8,
    any_filter_used: 9
  },
  defaultStage: 1,
  goals: {
    deals_filter_applied: 1,
    fd_of_offer_with_deal: 2,
    booked_with_deals_filter: 3,
    sr_offer_position_1_click: 4,
    sr_offer_position_2_to_5_click: 5
  },
  goalsWithValue: ["flights_flight_details_with_fare_discount_viewed"]
});

export const useTrackStagesAllDealsFilter = (anyFilterApplied: boolean, dealsFilterApplied: boolean) => {
  const { isMobile } = useProfiler();
  utils.stages.fare_discount_available(); //stage 2

  if (isMobile()) {
    utils.stages.m_dot_users(); // stage 5
  } else {
    utils.stages.d_dot_users(); // stage 3
    // This tracking needs to be completed based on split bounds experiment
    // utils.stages.d_dot_users_in_split_bound(); // stage 4
  }
  dealsFilterApplied ? utils.goals.deals_filter_applied() : null;
  anyFilterApplied ? utils.stages.any_filter_used() : null; // stage 9
};

export const useTrackCustomGoalWithValueAllDeals = (flight: UIFlightData | undefined) => {
  if (flight?.appliedDiscounts?.length) {
    utils.goalsWithValue.flights_flight_details_with_fare_discount_viewed(1);
  }
};

export default { useTrackStagesAllDealsFilter, useTrackCustomGoalWithValueAllDeals, ...utils };
